import React from 'react';
import Button, { HelpLink } from '../components/Button';
import IconButton from '@material-ui/core/IconButton';
import Drawer from '@material-ui/core/Drawer';
import { Scrollbar, Page as _Page, UIComponent } from './Base';
import { getHelpIcon, parseHelp } from './Help';
import { createIcon, runtime, Util } from '../common';
import { Divider } from '@material-ui/core';

// export class Page extends _Page {

//   constructor(props) {
//       super(props);
//       this.state = {
//           ...this.state,
//           screenHeight: window.document.body.offsetHeight,
//           screenWidth: window.document.body.offsetWidth
//       }
//   }


//   componentDidMount() {
//       super.componentDidMount();
//       this.screenChange();
//   }

//   screenChange() {
//       this.resizeRef = this.resize.bind(this);
//       window.addEventListener('resize', this.resizeRef);
//   }

//   componentWillUnmount() {
//       super.componentWillUnmount();    
//       window.removeEventListener('resize', this.resizeRef);
//   }

//   resize(e){
//     let screenWidth = window.document.body.offsetWidth;
//     let screenHeight = window.document.body.offsetHeight;
//       this.setState({
//         screenWidth,
//         screenHeight
//       });
//   }
// }


export class SearchBar extends UIComponent { //与SemiT结合使用的搜索栏

  constructor(props) {
    super(props);
    this.state = {
      value: ''
    }
  }

  field() {
    return this.props.field;
  }

  get() {
    return this.value;
  }

  onChange(e) {
    var value = e.target.value;
    this.setState({ value });
    this.value = value;
    let { onChange } = this.props;
    if (onChange) onChange();
  }

  render() {
    let { placeholder } = this.props;
    return (
      <div className="search-bar right-side-icon bg-transparent d-none d-sm-block">
        <div className="form-group">
          <input className="form-control border-0" type="search" placeholder={placeholder} onChange={this.onChange.bind(this)} />
          <button className="search-icon"><i className="zmdi zmdi-search zmdi-hc-lg" /></button>
        </div>
      </div>
    );
  }
};




export class SemiTPanel extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      drawerState: false
    }
  }

  sideBar = (drawer) => {
    let { title, icon, side } = this.props;
    if (drawer) {
      return (
        <div className="module-side">
          <div className="module-side-content c-flex-1">
            {side}
          </div>
        </div>)
    }
    return (
      <div className="module-side">
        <div className="module-side-header">
          <div className="module-logo">
            {icon ? createIcon(icon, "c-icon-s3") : null}
            <span className={`c-text-s3 ${icon ? "pl-2" : ''}`}>{title}</span>
          </div>
        </div>
        <div className="module-side-content c-flex-1">
          <Scrollbar className="module-side-scroll scrollbar h-100">
            {side}
          </Scrollbar>
        </div>
      </div>)
  };


  onToggleDrawer() {
    this.setState({
      drawerState: !this.state.drawerState
    });
  }

  render() {
    let { header, children, drawerBtn } = this.props;
    return (
      <div className="app-module c-m-0 h-100 c-semiTPanel" style={{ paddingBottom: runtime.pc ? 1 : 0 }}>
        <div className="d-block d-xl-none">
          <Drawer
            open={this.state.drawerState}
            onClose={this.onToggleDrawer.bind(this)}>
            {this.sideBar(true)}
          </Drawer>
        </div>
        <div className="app-module-sidenav d-none d-xl-flex">
          {this.sideBar()}
        </div>
        <div className="module-box bg-white">
          <div className="module-box-header">
            {
              drawerBtn || <IconButton className="drawer-btn d-block d-xl-none" aria-label="Menu"
                onClick={this.onToggleDrawer.bind(this)}>
                <i className="zmdi zmdi-menu" />
              </IconButton>
            }
            {header}
          </div>
          <div className="module-box-content c-flex-1">
            {
              <Scrollbar className="module-side-scroll scrollbar h-100">
                {children}
              </Scrollbar>
            }
          </div>
        </div>
      </div>
    )
  }
}



export class Grid extends React.Component {

  render() {
    let { children, className } = this.props;
    return (
      <div className={`c-grid row ${className}`}>
        {children}
      </div>
    )
  }
}

Grid.defaultProps = {
  className: 'my-3'
}

Grid.modalProps = {  //在窗口下，一般Grid会与Portal结合使用，因此不需要my-0
  className: 'my-0'
}


export class GridSection extends React.Component {

  render() {
    let { title, className, textClassName, help } = this.props;
    help = parseHelp(help);
    return (
      <div className={`c-gridSection col-12 d-flex flex-column ${className}`}>
        {help.url ? <div className={`mb-0 font-weight-bold ${textClassName}`}>{title}<HelpLink className="ml-1" href={help.url} /></div> : 
                <p className={`mb-0 font-weight-bold ${textClassName}`}>{title}</p>}
        {help.message ? <p className={`c-text-s1 m-text-muted mb-0`}>{help.message}</p> : null}
      </div>
    )
  }
}

GridSection.defaultProps = {
  title: "",
  className: 'mb-0 mt-4',
  textClassName: 'c-text-s1d5 m-text-dark75'
}

export class GridGroup extends React.Component {

  render() {
    let { title, className, textClassName } = this.props;
    return (
      <div className={`c-gridGroup col-12 d-flex flex-column ${className}`}>
        <p className={`mb-0 font-weight-bold ${textClassName}`}>{title}</p>
      </div>
    )
  }
}

GridGroup.defaultProps = {
  title: "",
  className: 'mb-0 mt-2',
  textClassName: 'c-text-s0 m-text-dark50'
}

export class GridCell extends React.Component {

  label(className) {
    let { label, labelClassName, labelWidth, layout, align } = this.props;
    if (layout == 'half') labelWidth = "50%";
    return label ? <div style={{ width: labelWidth }} className={`d-flex align-items-${align} text-grey mb-0 flex-nowrap ${className} ${labelClassName}`}>{label}</div> : null;
  }

  renderHelp() {

  }

  content() {
    let { has, content, right, layout, align, wrap, help } = this.props;
    if (align == "top") align = "start"; else if (align == "bottom") align = "end";
    let contentStyle = {};
    if (layout == "near") contentStyle.flex = 1;
    return <div className="d-flex flex-row justify-content-between c-flex-1">
      <div className={`d-flex flex-row  c-flex-1 justify-content-${layout == 'between' ? 'between' : 'start'}`}>
        {wrap ? null : this.label("mr-2")}
        <div className={`d-flex align-items-${align} text-${has ? 'dark' : 'grey'} c-text-s1d5 mb-0`} style={contentStyle}>{content}</div>
      </div>
      {
        right || help ?
          <div className="d-flex flex-row justify-content-center align-items-start ml-2">
            {right ? right : null}
            {help ? getHelpIcon(help, { className: "ml-3" }) : null}
          </div> : null
      }
    </div>
  }

  getSizeClassName() {
    let { size } = this.props;
    return getSizeClassName(size);
  }

  tryLeft(main){
    let { left } = this.props;
    if(!left) return main;
    return (
      <div className="d-flex flex-row">
        <div className="d-flex flex-column">
          {left}
        </div>
        <div className="d-flex flex-column c-flex-1">
          {main}
        </div>
      </div>
    );
  }

  render() {
    let { line, className, slim, average,children, wrap, onClick, layout,labelWidth } = this.props;
    if (layout === "single") return <SingleGridCell {...this.props} labelWidth={labelWidth==="auto"||!labelWidth?"7rem":labelWidth} />;
    let containerClassName = "pt-3 pb-1 pt-sm-4 pb-sm-2";
    if(slim) containerClassName = "pt-2 pb-1 pt-sm-3 pb-sm-1";
    if(average) containerClassName = "c-pt-1d5 c-pb-1d5";
    let p = {};
    if (onClick) p.onClick = (e) => { onClick(e); }
    return (
      <div className={`col-12 ${this.getSizeClassName()} d-flex flex-column ${containerClassName} ${className}`} {...p}>
        {this.tryLeft(
          <React.Fragment>
            {wrap ? this.label("mb-2") : null}
            {children || this.content()}
            {line ? <div className="mt-2 pb-2 c-lt w-100" /> : null}
          </React.Fragment>
        )}
      </div>
    )
  }
}

GridCell.defaultProps = {
  line: true,
  has: false,
  labelClassName: 'c-text-s1d5',
  className: '',
  slim: false,
  wrap: false,
  layout: "near",  //near,between,half
  align: "center",  //垂直的对齐方式
  labelWidth: 'auto',
  size: 12
}


class SingleGridCell extends React.Component {

  label() {
    let { label,labelClassName,labelWidth } = this.props;
    if(!label) return;
    return (
      <div className={"d-flex flex-column justify-content-start align-items-center  mr-2"}>
        <div style={{ width: labelWidth }} className={`text-grey ${labelClassName} c-py-3d5 mb-0 flex-nowrap`}>{label}</div>
      </div>
    )
  }

  content() {
    let { has, content, right, help, line } = this.props;
    return <div className={`d-flex flex-row justify-content-between align-items-center ${line ? 'c-lb' : ''} c-py-3d5 c-flex-1`}>
      <div className={`d-flex flex-column c-flex-1 justify-content-center align-items-start text-${has ? 'dark' : 'grey'} c-text-s1d5 mb-0`}>{content}</div>
      {
        right || help ?
          <div className="d-flex flex-row jutify-content-center align-items-center ml-3">
            {right ? right : null}
            {help ? getHelpIcon(help, { className: "ml-2" }) : null}
          </div> : null
      }
    </div>;
  }

  render() {
    let { line, className, size, onClick } = this.props;
    return (
      <div className={`col-12 ${getSizeClassName(size)} d-flex flex-row justify-content-start align-items-start ${className}`}>
        {this.label()}
        {this.content()}
      </div>
    )
  }
}

export class Container extends React.Component {

  constructor(props) {
    super(props);
  }

  scrollTop(top) {
    this.scrollbar.scrollTop(top||0);
  }

  tryScrollable(content) {
    let { innerNarrow, scrollable, scrollViewClassName } = this.props;
    scrollViewClassName = innerNarrow ? `d-flex flex-column justify-content-start align-items-center ${scrollViewClassName}` : scrollViewClassName;

    return (
      scrollable ? (
        <Scrollbar ref={(r) => { this.scrollbar = r; }} viewClassName={scrollViewClassName}>
          {content}
        </Scrollbar>
      ) : content
    );
  }

  render() {
    let { children, className, animated, style, center, onClick, full } = this.props;
    className = className || '';
    animated = animated || false;
    if (center) {
      if (center === true) center = 1300;//默认1300
      style = runtime.pc ? { width: center, ...style } : { ...style };
    }

    let props = {};
    if (onClick) {
      props.onClick = (e) => { onClick(e); }
    }

    return (
      <div className={`${animated ? 'animated slideInUpTiny animation-duration-3' : ''} c-container ${center ? 'c-container-center' : ''}  d-flex flex-column ${full ? 'h-100' : ''} ${className}`} style={style} {...props}>
        {this.tryScrollable(children)}
      </div>
    )
  }
}

Container.defaultProps = {
  full: true,
  scrollable: false,
  scrollViewClassName: ''
}


Container.narrowProps = { //容易内部是窄模式
  innerNarrow:true,
  full:true,
  scrollable:true
}




export function getSizeClassName(size) {
  if (Util.type(size) === "object") {
    let l = ["col-12"];
    for (let e in size) {
      l.push(`col-${e}-${size[e]}`);
    }
    return l.join(' ');
  }
  return `col-md-${size}`;
}